import { FC } from 'react'

import { RequestByIdType } from '@/api/models/requests/lib/requests.types'
import { PageType } from '@/components/entities/requests/model/types'
import GoBackButton from '@/components/shared/button/ui/GoBackButton'
import { useRequestNavigation } from '@/components/widgets/request/hooks/useRequestNavigation'

import RequestStatusBadge from '../../entities/requests/ui/RequestSummary/RequestStatusBadge'

type Props = {
  pageType: PageType
  request?: RequestByIdType
  isError?: boolean
}

export const RequestTitleDetails: FC<Props> = ({
  request,
  pageType,
  isError
}) => {
  const { shouldShowComments, navigateToContentsFromDetails } =
    useRequestNavigation()

  const handleOpenContent = () => {
    if (request?.id) {
      navigateToContentsFromDetails(pageType, request.id)
    }
  }

  return (
    <div className="flex flex-col gap-y-8">
      {shouldShowComments && !isError && (
        <div className="flex items-center gap-24 sm:gap-8">
          <GoBackButton onClick={handleOpenContent} />
          <span data-testid="request-chat-title-id">Чат</span>
        </div>
      )}
      {!shouldShowComments && (
        <>
          <h5 className="text-36 lg:text-28 sm:text-20">
            {(request?.title || request?.serviceName) ?? ''}
          </h5>
          <RequestStatusBadge
            status={request?.status}
            isDescriptionVisible
            statusNameTestId="request-details-status-name-id"
          />
        </>
      )}
    </div>
  )
}

export default RequestTitleDetails
